exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".side-menu{width:30%;padding:10px;position:fixed;z-index:1031;top:0;margin-top:10vh}.left-menu{left:0}.right-menu{right:0}.side-nav-wrapper{width:500px;position:fixed;top:0;margin-top:50px;left:100%;max-width:200%;z-index:1}.side-nav,.side-nav-wrapper{transition:all .4s ease 0s;height:100%}.side-nav{position:absolute;width:250px;left:0;background-color:#fff;width:50%}.side-nav .navbar-nav{margin-left:0}.side-nav.active{-webkit-transform:translate(-250px);transform:translate(-250px)}.side-nav li{line-height:40px;text-indent:20px}@media (min-width:767px){.wd-content{margin-left:30%}.side-nav-wrapper{display:none}}@media (min-width:1200px){.side-menu{width:400px}.wd-content{margin-left:400px}}@media (max-width:767px){.side-menu{display:none}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/client/app.component.css
// module id = 444
// module chunks = 1